export function baseUrl(path = ''): string {
  let url = import.meta.env.BASE_URL
  if (path) {
    url = url + (url.endsWith('/') ? '' : '/') + path.replace(/^\/|\/$/g, '')
  }
  return url
}
